import { API_CONFIG } from '../../config/api';
import { apiClient } from '../../lib/api-client';
import { AdminLoginEmailOtpDto, AdminLoginResponseDto, ApiResponse, VerifyOtpRequest } from '../../types/auth';

/**
 * Auth API Service
 * All authentication-related API calls should be defined here
 */
export const authApi = {
  /**
   * Request OTP for admin login
   */
  requestOtp: (data: AdminLoginEmailOtpDto): Promise<ApiResponse<{ message: string }>> =>
    apiClient.post(API_CONFIG.ENDPOINTS.AUTH.REQUEST_OTP, data, { requiresAuth: false }),

  /**
   * Verify OTP and login
   */
  verifyOtp: (data: VerifyOtpRequest): Promise<AdminLoginResponseDto> =>
    apiClient.post(API_CONFIG.ENDPOINTS.AUTH.VERIFY_OTP, data, { requiresAuth: false }),

  /**
   * Validate access token (optional - for checking if token is still valid)
   */
  validateToken: async (token: string): Promise<boolean> => {
    try {
      // You can implement a token validation endpoint if available
      // For now, we'll assume the token is valid if it exists
      return !!token;
    } catch {
      return false;
    }
  },
};

